/**
 * Query keys for the revenue opportunities table.
 *
 * The table renders from the campaign target, case, campaign, contact and
 * entity views. Each was a separately concatenated string, so no invalidation
 * could reach more than one at a time.
 */
export const revenueOpportunityKeys = {
  all: ["revenue-opportunities"],
  lists: () => [...revenueOpportunityKeys.all, "list"],
  list: ({
    entityId = null,
    campaignId = null,
    caseId = null,
    contactId = null,
  } = {}) => [
    ...revenueOpportunityKeys.lists(),
    { entityId, campaignId, caseId, contactId },
  ],
  detail: id => [...revenueOpportunityKeys.all, "detail", String(id)],
};
